/**
 * UIカスタマイズ可能な項目定義
 */
export type CustomStyleKey = (typeof customStyleKeys)[number];
export const customStyleKeys = [
  'typicalHeaderColor',
  'typicalHeaderFontFamily',
  'typicalHeaderFontFamilySimplifiedChinese',
  'typicalHeaderFontFamilyThai',
  'typicalHeaderFontFamilyVietnamese',
  'typicalHeaderFontColor',
  'typicalHeaderFontSizePc',
  'typicalHeaderFontSizeSp',
  'typicalHeaderFontWeight',
  'typicalLanguageIconColorPc',
  'typicalLanguageIconColorSp',
  'typicalLanguageIconFontColorPc',
  'typicalLanguageIconFontColorSp',
  'typicalLanguageMenuFontColor',
  'typicalLanguageMenuFontSize',
  'typicalLanguageMenuFontWeight',
  'typicalButtonInactiveColor',
  'typicalButtonInactiveFontColor',
  'typicalButtonInactiveFontSizePc',
  'typicalButtonInactiveFontSizeSp',
  'typicalButtonInactiveFontWeight',
  'typicalButtonActiveColor',
  'typicalButtonActiveFontColor',
  'typicalButtonActiveFontSizePc',
  'typicalButtonActiveFontSizeSp',
  'typicalButtonActiveFontWeight',
  'typicalDescriptionFontSizePc',
  'typicalDescriptionFontSizeSp',
  'typicalDescriptionFontWeight',
  'typicalSubtitleColor',
  'typicalSubtitleFontColor',
  'typicalSubtitleFontSizePc',
  'typicalSubtitleFontSizeSp',
  'typicalSubtitleFontWeight',
  'termsPolicyDescriptionFontSizePc',
  'termsPolicyDescriptionFontSizeSp',
  'termsPolicyDescriptionFontWeight',
  'personalInformationRadioButtonIconColor',
  'personalInformationDocumentNameFontSizePc',
  'personalInformationDocumentNameFontSizeSp',
  'personalInformationDocumentNameFontWeight',
  'personalInformationAttentionBackgroundColor',
  'personalInformationAttentionFontColor',
  'personalInformationAttentionFontSizePc',
  'personalInformationAttentionFontSizeSp',
  'personalInformationAttentionFontWeight',
  'personalInformationCheckboxNonActiveIconColor',
  'personalInformationCheckboxActiveIconColor',
  'personalInformationCheckboxMessageBackgroundColor',
  'personalInformationCheckboxMessageFontColor',
  'personalInformationCheckboxMessageFontSizePc',
  'personalInformationCheckboxMessageFontSizeSp',
  'personalInformationCheckboxMessageFontWeight',
  'instructionHeaderColor',
  'instructionFontColor',
  'instructionFontSizePc',
  'instructionFontSizeSp',
  'instructionFontWeight',
  'instructionSubTitleFontSizePc',
  'instructionSubTitleFontSizeSp',
  'instructionSubTitleFontWeight',
  'instructionDescriptionFontSizePc',
  'instructionDescriptionFontSizeSp',
  'instructionDescriptionFontWeight',
  'instructionScreenColor',
  'shootingHeaderColor',
  'shootingFontColor',
  'shootingFontSizePc',
  'shootingFontSizeSp',
  'shootingFontWeight',
  'shootingFrameBorderColor',
  'shootingFrameImageColor',
  'shootingPopupColor',
  'shootingPopupFontColor',
  'shootingPopupFontSize',
  'shootingPopupFontWeight',
  'shootingButtonColor',
  'shootingIconColor',
  'shootingScreenColor',
  'shootingDiagonalDescriptionFontColor',
  'shootingDiagonalDescriptionFontSize',
  'shootingDiagonalDescriptionFontWeight',
  'shootingDiagonal2DescriptionFontColor',
  'shootingDiagonal2DescriptionFontSize',
  'shootingDiagonal2DescriptionFontWeight',
  'shootingDiagonalIllustrationColor',
  'shootingAutoPopupFrameBorderColor',
  'shootingAutoPopupColor',
  'shootingAutoPopupFontColor',
  'shootingAutoPopupFontSize',
  'shootingAutoPopupFontWeight',
  'shootingAutoFrameColorBefore',
  'shootingAutogFrameColorAfter',
  'shootingAutoCompleteIconColor',
  'shootingAutoScreenColor',
  'confrimationDescriptionColor',
  'confrimationDescriptionFontSizePc',
  'confrimationDescriptionFontSizeSp',
  'confrimationDescriptionFontWeight',
  'confrimationCheckboxInactiveIconColor',
  'confrimationCheckboxActiveIconColor',
  'confrimationGpOpCheckboxInactiveIconColor',
  'confrimationGpOpCheckboxActiveIconColor',
  'confrimationCheckMessageFontSizePc',
  'confrimationCheckMessageFontSizeSp',
  'confrimationCheckMessageFontWeight',
  'confrimationRetakeButtonColor',
  'confrimationRetakeButtonFontSizePc',
  'confrimationRetakeButtonFontSizeSp',
  'confrimationRetakeButtonFontWeight',
  'actionDescriptionFontSizePc',
  'actionDescriptionFontSizeSp',
  'actionDescriptionFontWeight',
  'actionShootCountIconCurrentColor',
  'actionShootFrameBorderColor',
  'actionShootIconArrowColor',
  'actionShootIconArrowGuideFontSizePc',
  'actionShootIconArrowGuideFontSizeSp',
  'actionShootIconArrowGuideFontWeight',
  'actionShootCountIconPastColor',
  'actionShootIconCompleteColor',
  'actionShootIconCompleteMessageColor',
  'completeIconColor',
  'completeDescriptionFontColor',
  'completeDescriptionFontSize',
  'completeDescriptionFontWeight',
  'completeDescription2FontColor',
  'completeDescription2FontSize',
  'completeDescription2FontWeight',
  'modalHeaderColor',
  'modalHeaderFontColor',
  'modalHeaderFontSize',
  'modalHeaderFontWeight',
  'modalMessageFontColor',
  'modalMessageFontSize',
  'modalMessageFontWeight',
  'modalLeftButtonColor',
  'modalLeftButtonFontColor',
  'modalLeftButtonFontSize',
  'modalLeftButtonFontWeight'
] as const;

export const toCssVariable = (key: CustomStyleKey) => {
  const snakeCase = key.replace(/([A-Z])/g, '-$1').toLowerCase() as CamelToKebabCase<CustomStyleKey>;
  return `--${snakeCase}` as `--${typeof snakeCase}`;
};

/**
 * カスタムスタイルのデフォルト値設定
 * CSSのvarの第二引数でデフォルト値を設定するだけでは、無効な値がCSS変数に入った時にフォールバックされない
 * @see https://developer.mozilla.org/ja/docs/Web/CSS/Using_CSS_custom_properties#%E5%80%A4%E3%81%A8%E5%A6%A5%E5%BD%93%E6%80%A7
 *
 * なので @property を使用して、値をバリデーションし、無効であれば初期値を使用するようにする
 * @see https://developer.mozilla.org/ja/docs/Web/CSS/@property
 */

/** @see https://github.com/dogmanet/SkyXEngine/blob/branchX/source/gui2/css.txt */
const syntaxes = {
  color: '<color>',
  colorGradient: '<color> | linear-gradient( [ <angle> | to <side-or-corner> ]? , <color-stop-list> )',
  fontSize:
    'xx-small | x-small | small | medium | large | x-large | xx-large | xxx-large | larger | smaller | <length-percentage>',
  fontFamily: '*',
  fontWeight: 'normal | bold | <integer> | bolder | lighter'
} as const;
type PropertyRule = {
  syntax: (typeof syntaxes)[keyof typeof syntaxes];
  default: string;
};
export const propertyRules: {
  [key in CustomStyleKey]: PropertyRule;
} = {
  typicalHeaderColor: { syntax: syntaxes.color, default: '#14a8c8' },
  typicalHeaderFontFamily: {
    syntax: syntaxes.fontFamily,
    default: `Noto Sans, Noto Sans JP, Avenir, Helvetica, Arial, sans-serif`
  },
  typicalHeaderFontFamilySimplifiedChinese: {
    syntax: syntaxes.fontFamily,
    default: `PingFang SC, Hiragino Sans GB, Microsoft YaHei, sans-serif`
  },
  typicalHeaderFontFamilyThai: {
    syntax: syntaxes.fontFamily,
    default: `Leelawadee, thonburi, Tahoma, sans-serif`
  },
  typicalHeaderFontFamilyVietnamese: {
    syntax: syntaxes.fontFamily,
    default: `Helvetica Neue, Helvetica, Arial, sans-serif`
  },
  typicalHeaderFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  typicalHeaderFontSizePc: { syntax: syntaxes.fontSize, default: '24px' },
  typicalHeaderFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  typicalHeaderFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  typicalLanguageIconColorPc: { syntax: syntaxes.color, default: '#ffffff' },
  typicalLanguageIconColorSp: { syntax: syntaxes.color, default: '#ffffff' },
  typicalLanguageIconFontColorPc: { syntax: syntaxes.color, default: '#ffffff' },
  typicalLanguageIconFontColorSp: { syntax: syntaxes.color, default: '#000000' },
  typicalLanguageMenuFontColor: { syntax: syntaxes.color, default: '#14a8c8' },
  typicalLanguageMenuFontSize: { syntax: syntaxes.fontSize, default: '16px' },
  typicalLanguageMenuFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  typicalButtonInactiveColor: { syntax: syntaxes.color, default: '#dddddd' },
  typicalButtonInactiveFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  typicalButtonInactiveFontSizePc: { syntax: syntaxes.fontSize, default: '20px' },
  typicalButtonInactiveFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  typicalButtonInactiveFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  typicalButtonActiveColor: { syntax: syntaxes.colorGradient, default: '#1bb0d1' },
  typicalButtonActiveFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  typicalButtonActiveFontSizePc: { syntax: syntaxes.fontSize, default: '20px' },
  typicalButtonActiveFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  typicalButtonActiveFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  typicalDescriptionFontSizePc: { syntax: syntaxes.fontSize, default: '16px' },
  typicalDescriptionFontSizeSp: { syntax: syntaxes.fontSize, default: '14px' },
  typicalDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  typicalSubtitleColor: { syntax: syntaxes.color, default: '#dddddd' },
  typicalSubtitleFontColor: { syntax: syntaxes.color, default: '#333333' },
  typicalSubtitleFontSizePc: { syntax: syntaxes.fontSize, default: '18px' },
  typicalSubtitleFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  typicalSubtitleFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  termsPolicyDescriptionFontSizePc: { syntax: syntaxes.fontSize, default: '32px' },
  termsPolicyDescriptionFontSizeSp: { syntax: syntaxes.fontSize, default: '24px' },
  termsPolicyDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '700' },
  personalInformationRadioButtonIconColor: { syntax: syntaxes.color, default: '#3e8ed0' },
  personalInformationDocumentNameFontSizePc: { syntax: syntaxes.fontSize, default: '15px' },
  personalInformationDocumentNameFontSizeSp: { syntax: syntaxes.fontSize, default: '14px' },
  personalInformationDocumentNameFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  personalInformationAttentionBackgroundColor: { syntax: syntaxes.color, default: '#fff3f3' },
  personalInformationAttentionFontColor: { syntax: syntaxes.color, default: '#333333' },
  personalInformationAttentionFontSizePc: { syntax: syntaxes.fontSize, default: '15px' },
  personalInformationAttentionFontSizeSp: { syntax: syntaxes.fontSize, default: '13px' },
  personalInformationAttentionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  personalInformationCheckboxNonActiveIconColor: { syntax: syntaxes.color, default: '#7a7a7a' },
  personalInformationCheckboxActiveIconColor: { syntax: syntaxes.color, default: '#3e8ed0' },
  personalInformationCheckboxMessageBackgroundColor: { syntax: syntaxes.color, default: '#ecf5ff' },
  personalInformationCheckboxMessageFontColor: { syntax: syntaxes.color, default: '#333333' },
  personalInformationCheckboxMessageFontSizePc: { syntax: syntaxes.fontSize, default: '15px' },
  personalInformationCheckboxMessageFontSizeSp: { syntax: syntaxes.fontSize, default: '13px' },
  personalInformationCheckboxMessageFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  instructionHeaderColor: { syntax: syntaxes.color, default: 'transparent' },
  instructionFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  instructionFontSizePc: { syntax: syntaxes.fontSize, default: '24px' },
  instructionFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  instructionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  instructionSubTitleFontSizePc: { syntax: syntaxes.fontSize, default: '24px' },
  instructionSubTitleFontSizeSp: { syntax: syntaxes.fontSize, default: '22px' },
  instructionSubTitleFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  instructionDescriptionFontSizePc: { syntax: syntaxes.fontSize, default: '16px' },
  instructionDescriptionFontSizeSp: { syntax: syntaxes.fontSize, default: '15px' },
  instructionDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  instructionScreenColor: { syntax: syntaxes.color, default: '#000000' },
  shootingHeaderColor: { syntax: syntaxes.color, default: '#000000' },
  shootingFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  shootingFontSizePc: { syntax: syntaxes.fontSize, default: '24px' },
  shootingFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  shootingFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  shootingFrameBorderColor: { syntax: syntaxes.color, default: '#3cf5ff' },
  shootingFrameImageColor: { syntax: syntaxes.color, default: '#3cf5ff' },
  shootingPopupColor: { syntax: syntaxes.color, default: '#fac51f' },
  shootingPopupFontColor: { syntax: syntaxes.color, default: '#333333' },
  shootingPopupFontSize: { syntax: syntaxes.fontSize, default: '11px' },
  shootingPopupFontWeight: { syntax: syntaxes.fontWeight, default: '700' },
  shootingButtonColor: { syntax: syntaxes.color, default: '#ffffff' },
  shootingIconColor: { syntax: syntaxes.color, default: '#00b5d9' },
  shootingScreenColor: { syntax: syntaxes.color, default: '#000000' },
  shootingDiagonalDescriptionFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  shootingDiagonalDescriptionFontSize: { syntax: syntaxes.fontSize, default: '16px' },
  shootingDiagonalDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  shootingDiagonal2DescriptionFontColor: { syntax: syntaxes.color, default: '#ffb500' },
  shootingDiagonal2DescriptionFontSize: { syntax: syntaxes.fontSize, default: '22px' },
  shootingDiagonal2DescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  shootingDiagonalIllustrationColor: { syntax: syntaxes.color, default: '#FFB500' },
  shootingAutoPopupFrameBorderColor: { syntax: syntaxes.color, default: '#3cf5ff' },
  shootingAutoPopupColor: { syntax: syntaxes.color, default: '#000000' },
  shootingAutoPopupFontColor: { syntax: syntaxes.color, default: '#ffffff' },
  shootingAutoPopupFontSize: { syntax: syntaxes.fontSize, default: '15px' },
  shootingAutoPopupFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  shootingAutoFrameColorBefore: { syntax: syntaxes.color, default: '#3cf5ff' },
  shootingAutogFrameColorAfter: { syntax: syntaxes.color, default: '#43e21c' },
  shootingAutoCompleteIconColor: { syntax: syntaxes.color, default: '#8FE25E' },
  shootingAutoScreenColor: { syntax: syntaxes.color, default: '#000000' },
  confrimationDescriptionColor: { syntax: syntaxes.color, default: '#1bb0d1' },
  confrimationDescriptionFontSizePc: { syntax: syntaxes.fontSize, default: '18px' },
  confrimationDescriptionFontSizeSp: { syntax: syntaxes.fontSize, default: '14px' },
  confrimationDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  confrimationCheckboxInactiveIconColor: { syntax: syntaxes.color, default: '#7a7a7a' },
  confrimationCheckboxActiveIconColor: { syntax: syntaxes.color, default: '#43e21c' },
  confrimationGpOpCheckboxInactiveIconColor: { syntax: syntaxes.color, default: '#3e8ed0' },
  confrimationGpOpCheckboxActiveIconColor: { syntax: syntaxes.color, default: '#3e8ed0' },
  confrimationCheckMessageFontSizePc: { syntax: syntaxes.fontSize, default: '15px' },
  confrimationCheckMessageFontSizeSp: { syntax: syntaxes.fontSize, default: '14px' },
  confrimationCheckMessageFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  confrimationRetakeButtonColor: { syntax: syntaxes.color, default: '#1bb0d1' },
  confrimationRetakeButtonFontSizePc: { syntax: syntaxes.fontSize, default: '20px' },
  confrimationRetakeButtonFontSizeSp: { syntax: syntaxes.fontSize, default: '16px' },
  confrimationRetakeButtonFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  actionDescriptionFontSizePc: { syntax: syntaxes.fontSize, default: '16px' },
  actionDescriptionFontSizeSp: { syntax: syntaxes.fontSize, default: '20px' },
  actionDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  actionShootCountIconCurrentColor: { syntax: syntaxes.color, default: '#25bddd' },
  actionShootFrameBorderColor: { syntax: syntaxes.color, default: '#25bddd' },
  actionShootIconArrowColor: { syntax: syntaxes.color, default: '#25bddd' },
  actionShootIconArrowGuideFontSizePc: { syntax: syntaxes.fontSize, default: '16px' },
  actionShootIconArrowGuideFontSizeSp: { syntax: syntaxes.fontSize, default: '20px' },
  actionShootIconArrowGuideFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  actionShootCountIconPastColor: { syntax: syntaxes.color, default: '#000000' },
  actionShootIconCompleteColor: { syntax: syntaxes.color, default: '#8FE25E' },
  actionShootIconCompleteMessageColor: { syntax: syntaxes.color, default: '#43e21c' },
  completeIconColor: { syntax: syntaxes.color, default: '#4FEC29' },
  completeDescriptionFontColor: { syntax: syntaxes.color, default: '#333333' },
  completeDescriptionFontSize: { syntax: syntaxes.fontSize, default: '18px' },
  completeDescriptionFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  completeDescription2FontColor: { syntax: syntaxes.color, default: '#555555' },
  completeDescription2FontSize: { syntax: syntaxes.fontSize, default: '14px' },
  completeDescription2FontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  modalHeaderColor: { syntax: syntaxes.color, default: '#ffffff' },
  modalHeaderFontColor: { syntax: syntaxes.color, default: '#000000' },
  modalHeaderFontSize: { syntax: syntaxes.fontSize, default: '16px' },
  modalHeaderFontWeight: { syntax: syntaxes.fontWeight, default: '700' },
  modalMessageFontColor: { syntax: syntaxes.color, default: '#333333' },
  modalMessageFontSize: { syntax: syntaxes.fontSize, default: '15px' },
  modalMessageFontWeight: { syntax: syntaxes.fontWeight, default: '400' },
  modalLeftButtonColor: { syntax: syntaxes.color, default: '#ffffff' },
  modalLeftButtonFontColor: { syntax: syntaxes.color, default: '#777777' },
  modalLeftButtonFontSize: { syntax: syntaxes.fontSize, default: '16px' },
  modalLeftButtonFontWeight: { syntax: syntaxes.fontWeight, default: '400' }
};
